import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const ThrowbackCoupon = loadable(() => pMinDelay(import('./ThrowbackCoupon'), 300), {
  fallback: <Loading />
});

const AsyncThrowbackCoupon = props => {
  const pageConfig = {
    headerType: 'mobile-none',
    footerType: 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation tb-page-background`
      },
      title: 'Bilyoner.com | Tarihe Bugün'
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <ThrowbackCoupon { ...props }/>
    </ApplicationLayout>
  );
};

AsyncThrowbackCoupon.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncThrowbackCoupon;
